<app-base-list-wrapper [baseListComponent]="this">
    <ng-template #moreButtons let-table>
        <p-button
            *ngIf="showAddEInvoiceDetails()"
            outlined="true"
            label="{{ 'address.add-electronic-invoice-details' | translate }}"
            (click)="addEInvoiceDetails()"
            data-testid="add-e-invoice-details"
            icon="fa-solid fa-plus"
            styleClass="animate-fadein"
            [loading]="showAddEInvoiceDetailsButtonLoading()"
        ></p-button>
    </ng-template>
</app-base-list-wrapper>
